export default {
  title: 'Encuestas',
  subtitle: 'Gestión de campañas y resultados',

  audiences: {
    STUDENTS: 'Estudiantes',
    TEACHERS: 'Docentes',
    DATA_SYSTEM: 'Data System',
  },

  campaigns: {
    title: 'Campañas',
    new: 'Nueva campaña',
    edit: 'Editar campaña',
    empty: 'Todavía no hay campañas para esta audiencia',
    col_name: 'Nombre',
    col_starts_at: 'Desde',
    col_ends_at: 'Hasta',
    col_status: 'Estado',
    col_responses: 'Respuestas',
    col_countries: 'Países',
    col_actions: 'Acciones',
    all_countries: 'Todos los países',
    status: {
      ACTIVE: 'Activa',
      SCHEDULED: 'Programada',
      FINISHED: 'Finalizada',
      INACTIVE: 'Inactiva',
    },
    form: {
      name: 'Nombre',
      starts_at: 'Fecha de inicio',
      ends_at: 'Fecha de fin',
      dates_hint: 'La encuesta se muestra mientras la fecha de hoy esté dentro del rango.',
      countries: 'Países',
      countries_hint: 'Deja vacío para dirigir la campaña a todos los países.',
      save: 'Guardar',
      cancel: 'Cancelar',
      required: 'Este campo es obligatorio',
      dates_order: 'La fecha de inicio no puede ser posterior a la de fin',
    },
    delete: {
      title: 'Eliminar campaña',
      confirm: '¿Seguro que quieres eliminar la campaña "{name}"? Esta acción no se puede deshacer.',
      accept: 'Eliminar',
      cancel: 'Cancelar',
      has_responses: 'No puedes eliminar una campaña que ya tiene respuestas.',
    },
    created: 'Campaña creada',
    updated: 'Campaña actualizada',
    deleted: 'Campaña eliminada',
    overlap: 'Las fechas se superponen con otra campaña de la misma audiencia.',
    deactivate: {
      title: 'Desactivar campaña',
      confirm: '¿Deseas desactivar la campaña "{name}"? Dejará de aceptar respuestas nuevas, pero conserva los datos históricos.',
      accept: 'Desactivar',
      cancel: 'Cancelar',
    },
    activated: 'Campaña activada',
    deactivated: 'Campaña desactivada',
  },

  export: {
    button: 'Exportar CSV',
    col_score: 'Puntaje',
    col_count: 'Cantidad',
    col_percentage: 'Porcentaje',
    negative_only: 'Solo negativos',
  },

  results: {
    title: 'Resultados: {name}',
    no_campaign: 'Elige una campaña para ver sus resultados',
    no_data: 'Esta campaña todavía no tiene respuestas',
    load_error: 'No se pudieron cargar los resultados. Inténtalo de nuevo.',
    filter_country: 'País',
    filter_school: 'Colegio',
    filter_all: 'Todos',
  },

  nps: {
    score: 'NPS',
    responses: 'Respuestas',
    average: 'Puntaje promedio',
    promoters: 'Promotores',
    passives: 'Pasivos',
    detractors: 'Detractores',
    distribution_title: 'Distribución de puntajes',
    breakdown_title: 'Resultados por segmento',
    by_school: 'Colegio',
    by_country: 'País',
    col_segment: 'Segmento',
    col_responses: 'Respuestas',
    col_nps: 'NPS',
    col_average: 'Promedio',
    comments_title: 'Comentarios',
    comments_empty: 'Esta campaña no tiene comentarios',
    comments_empty_negative: 'Esta campaña no tiene comentarios negativos',
    col_user: 'Usuario',
    col_score: 'Puntaje',
    col_comment: 'Comentario',
    col_school: 'Colegio',
    col_country: 'País',
    col_date: 'Fecha',
  },
};
